export default __webpack_public_path__ + "static/media/rarity6.f1238731.mp4";